// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f4614c9","455":"79215173","977":"f1c767a0"}[chunkId] + ".chunk.js";
};